// semeia-disable-reexport
import { sortBy } from "./sort";

export function activeJournalEvents(...args) {
  const descriptor = args[2];
  return {
    ...descriptor,
    get() {
      return descriptor.get
        .call(this)
        .filter(je => !je.isArchived)
        .sort(sortBy("occurredAt"));
    }
  };
}
